import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import {
    Field,
    ISelectTypeFieldProps,
} from "@formant/ui/component/common/Field";
import { Icon } from "@formant/ui/component/common/Icon";

import * as styles from "./SelectField.scss";

interface ISelectFieldProps
    extends ISelectTypeFieldProps, ITestableComponentProps {
    children: ReactNode;
}

export class SelectField extends Component<ISelectFieldProps> {
    public render() {
        const {
            className,
            disabled,
            readOnly,
            value,
            small,
            onChange,
            children,
            onFocus,
            onClick,
            onBlur,
        } = this.props;

        return (
            <Field
                data-testid={this.props["data-testid"]}
                {...this.props}
                className={classnames(
                    styles["select-field"],
                    className,
                    !value && styles.empty,
                    small && styles.small,
                )}
                filledOut={value !== undefined}
            >
                <span className={styles.select}>
                    <select
                        {...{
                            disabled,
                            readOnly,
                            value,
                            onChange,
                            onFocus,
                            onBlur,
                            onClick,
                        }}
                        data-testid={this.props["data-testid"]}
                    >
                        {children}
                    </select>
                    {!readOnly && !disabled && <Icon name="dropdown" />}
                </span>
            </Field>
        );
    }
}
